import { Snackbar, Alert } from '@mui/material';

interface MessageNotificationsProps {
    approveSuccess: boolean;
    approveError: string | null;
    onSuccessClose: () => void;
    onErrorClose: () => void;
}

export function MessageNotifications({
    approveSuccess,
    approveError,
    onSuccessClose,
    onErrorClose
}: MessageNotificationsProps) {
    return (
        <>
            {/* Success Notification */}
            <Snackbar 
                open={approveSuccess} 
                autoHideDuration={6000} 
                onClose={onSuccessClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert 
                    onClose={onSuccessClose} 
                    severity="success" 
                    sx={{ width: '100%' }}
                >
                    Message approved successfully!
                </Alert>
            </Snackbar>
            
            {/* Error Notification */}
            <Snackbar 
                open={!!approveError} 
                autoHideDuration={6000} 
                onClose={onErrorClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={onErrorClose} severity="error" sx={{ width: '100%' }}>
                    {approveError}
                </Alert>
            </Snackbar>
        </>
    );
}